import React, { createContext, useState, useEffect } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore"; // Import Firestore functions

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true); // Track loading state

  useEffect(() => {
    const auth = getAuth();
    const db = getFirestore(); // Initialize Firestore

    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        // Fetch the user's role from Firestore using the user's UID
        const userRef = doc(db, "Users", user.uid); // "users" is your Firestore collection
        const userDoc = await getDoc(userRef);

        if (userDoc.exists()) {
          const userData = userDoc.data();
          setCurrentUser({ ...user, role: userData.role || "user" }); // Default to 'user' if no role exists
        } else {
          setCurrentUser({ ...user, role: "user" }); // Default to 'user' if no role exists
        }
      } else {
        setCurrentUser(null); // Set currentUser to null if user is logged out
      }

      setLoading(false); // Once data is fetched, set loading to false
    });

    return () => unsubscribe(); // Cleanup listener on unmount
  }, []);

  return (
    <AuthContext.Provider value={{ currentUser, loading }}>
      {children}
    </AuthContext.Provider>
  );
};
